import React from "react";
import styled from "styled-components";

const ExternalLinkContainer = styled.span`
  display: inline-block;

  & a {
    display: inline-flex;
    flex-direction: row;
    flex-wrap: nowrap;
    color: var(--link-color);
  }
`;

export const ExternalTableLink: React.FC<
  React.DetailedHTMLProps<
    React.AnchorHTMLAttributes<HTMLAnchorElement>,
    HTMLAnchorElement
  > & { stayVisible?: boolean }
> = (props) => (
  <ExternalLinkContainer>
    <a
      {...props}
      style={{ display: "inline-flex", flexWrap: "nowrap" }}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
    >
      {props.children}&nbsp;
    </a>
  </ExternalLinkContainer>
);
